import { FaPlus, FaMinus, FaInfoCircle } from "react-icons/fa";
import TextFieldCustom from "../../../../component/elements/textfieldCustom";
import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../../../configuration/request";
import { useSnackbar } from "../../../../component/SnackbarContext";
import { useDispatch, useSelector } from "react-redux";
import {
  removeCartItem,
  setCartItems,
} from "../../../../Redux/Slices/customerSlice";

import ClothWeightInfoModal from "../../components/ClothWeightInfoModal";


export default function WashAndFold() {
  const showSnackbar = useSnackbar();
  const [showWeightInfo, setShowWeightInfo] = useState(false);
  const dispatch = useDispatch();
  const { cartItems, orderFlow, selectedService, selectedShop } = useSelector(
    (state) => state.customer
  );
  const [services, setServices] = useState([]);
  useEffect(() => {
    if (orderFlow === "shop") {
      fetchShopServices();
    } else {
      fetchServices();
    }
  }, []);

  const fetchShopServices = async () => {
    const res = await axiosInstance.get(
      `/customer/services-offered/getServiceBasedonStore?store_id=${selectedShop?.id}&service_name=WASH_N_FOLD`
    );
    let mappedData = res?.data[0].poundDetails;
    const initial = mappedData.map((data) => {
      const inCart = cartItems.find(
        (cartItem) => cartItem.name === data?.category
      );
      return {
        name: data?.category,
        weight: inCart ? inCart.weight : "",
      };
    });
    setServices(initial);
  };

  const fetchServices = async () => {
    const data = await fetchDropdownData("wash_fold");
    const initial = data.map((name) => {
      const inCart = cartItems.find((cartItem) => cartItem.name === name);
      return {
        name,
        weight: inCart ? inCart.weight : "",
      };
    });
    setServices(initial);
  };

  const fetchDropdownData = async (label) => {
    try {
      const res = await axiosInstance.get(`/customer/core/dropdown/${label}`);
      return res?.data?.value || [];
    } catch (error) {
      showSnackbar(
        error?.response?.data?.message || "Something went wrong!",
        "error"
      );
      return [];
    }
  };

  const handleWeightChange = (value, index) => {
    setServices((prev) => {
      const updated = [...prev];
      updated[index].weight = value;
      return updated;
    });
  };

  const handleAdd = (item) => {
    if (!item.weight || Number(item.weight) <= 0) {
      showSnackbar("Please enter weight before adding to cart!", "error");
      return;
    }
    dispatch(
      setCartItems({
        name: item.name,
        weight: item.weight,
        tailoringType: [],
        category: "",
      })
    );
  };

  const handleRemove = (item) => {
    dispatch(removeCartItem({ name: item.name }));
    setServices((prev) =>
      prev.map((service) =>
        service.name === item.name ? { ...service, weight: "" } : service
      )
    );
  };

  const isInCart = (name) => {
    if (cartItems) {
      return cartItems.some((i) => i.name === name);
    }
  };

  return (
    <div className="w-full">
      <div className="flex justify-end mb-3">
  <button
    className="flex items-center gap-1 text-sm text-[#1876A9]"
    onClick={() => setShowWeightInfo(true)}
  >
    <FaInfoCircle /> Weight Guide
  </button>
</div>

      <div className="space-y-4 mt-5">
        {services.map((item, idx) => {
          const inCart = isInCart(item.name);
          return (
            <div
              key={idx}
              className={`flex justify-between items-center px-4 py-3 rounded-full border-[2px] transition-all ${inCart
                  ? "border-[#1876A9] text-[#1876A9]"
                  : "border-[#D8DAE5] text-gray-800 bg-white"
                }`}
            >
              <span
                className="font-[600] text-base xlg:text-lg"
              >
                {item?.name}
              </span>
              <div className="flex gap-4 items-center max-w-[28px] min-w-[250px] ">
                <div className=" max-w-[150px] ml-2">
                  <TextFieldCustom
                    placeholder="Weight"
                    fullWidth
                    value={item.weight}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (/^\d*\.?\d{0,2}$/.test(val))
                        handleWeightChange(val, idx);
                    }}
                    heightClass="lbs-textfield"
                    disabled={inCart}
                  />
                </div>
                {inCart ? (
                  <button
                    className="flex w-[90px] h-[30px] justify-center items-center  bg-[#FFDADA] text-[#D9534F] text-xs font-semibold rounded-full"
                    onClick={() => handleRemove(item)}
                  >
                    Remove
                  </button>
                ) : (
                  <button
                    className="flex w-[90px] h-[30px] justify-center items-center  bg-[#DEEDF6] text-[#1876A9] text-xs font-semibold  rounded-full"
                    onClick={() => handleAdd(item)}
                  >
                    <FaPlus className="mr-1" /> Add
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <ClothWeightInfoModal
  open={showWeightInfo}
  onClose={() => setShowWeightInfo(false)}
/>

    </div>
    
  );
}


//  <div className="flex items-center space-x-2 bg-[#DEEDF6] px-2 py-2 rounded-full">
//               <button className="w-[24px] h-[24px] text-[13px] flex justify-center items-center bg-[#F7F8F9] text-[#64748B] rounded-full">
//                 <FaPlus />
//               </button>
//               <span className="text-sm font-semibold w-6 text-center">
//                 {item.value}
//               </span>
//               <button className="w-[24px] h-[24px] text-[13px] flex justify-center items-center bg-[#F7F8F9] text-[#64748B] rounded-full">
//                 <FaMinus />
//               </button>
//             </div>
